import { PhysicalLocation } from '@tribeplatform/gql-client/types'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { T } from '../../i18n/index.js'
import { MapImageRenderer } from '../Components/MapImageRenderer.js'

import { Section } from './Section.js'

interface Props {
  locations?: PhysicalLocation[]
}

export const EventLocationMap = ({ locations }: Props) => {
  const location = locations?.at(0)

  if (!location) {
    return null
  }

  return (
    <Section title={<T id="Generics.Location" defaultMessage="Location" />}>
      <Text className="text-content-subdued">{location?.formattedAddress}</Text>
      {location?.additionalData && (
        <Text className="text-content-subdued">{location?.additionalData}</Text>
      )}
      {location.mapUrls && (
        <MapImageRenderer
          latitude={location.latitude}
          longitude={location.longitude}
          placeId={location.placeId}
          urls={location.mapUrls}
        />
      )}
    </Section>
  )
}
